import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param sApi 查询接口 

     * @param callback
     * @returns {Function}
     */
    postHttpAction(sApi,data,sMethod='POST') {
        return request({
            url:  sApi,
            method: sMethod,
            data
        });
    }
};

export default SearchApiService;
